import { render, staticRenderFns } from "./BotaoDashboardPssc.vue?vue&type=template&id=25db079a&lang=pug"
import script from "./BotaoDashboardPssc.vue?vue&type=script&lang=js"
export * from "./BotaoDashboardPssc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports